








































import { defineComponent, ref, watch } from '@vue/composition-api';

export default defineComponent({
	emits: ['open', 'close'],
	setup(_, { emit }) {
		const isOpen = ref(false);
		const links = [
			['Costs and timeline', 'https://our-sci.gitlab.io/software/soilstack-tutorials/start_stratification/'],
			['Stratification Settings', 'https://our-sci.gitlab.io/software/soilstack-tutorials/stratification_settings/'],
			['Stratification Process', 'https://our-sci.gitlab.io/software/soilstack-tutorials/stratification_process/'],
		];

		watch(isOpen, (val) => {
			emit(val ? 'open' : 'close');
		});

		return {
			isOpen,
			links,
		};
	},
});
